module.exports = __webpack_public_path__ + "static/media/secondnature_ai.ae51e000.png";